import { useState, useEffect } from 'react';
import useAxios from 'axios-hooks';
import { navigate } from 'raviger';
import { reactLocalStorage } from 'reactjs-localstorage';

export const useUser = (login) => {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState();
  const [invalid, setInvalid] = useState(false);
  const [userId, setUserId] = useState();
  const [hideChange, setHideChange] = useState(false);
  const [orgName, setOrgName] = useState();
  const [showAcceptTerms, setShowAcceptTerms] = useState()

  //Authetication request
  const [
    { data: dataLogin, loading: loadingLogin, error: errorLogin },
    executeLogin,
  ] = useAxios(
    {
      url: 'auth',
      method: 'POST',
    },
    { manual: true }
  );

  //Get user by id request
  const [
    { data: dataUser, loading: loadingUser, error: errorUser },
    executeUser,
  ] = useAxios(`users/${userId}`, { manual: true });

  //Token validation request
  const [
    { data: dataToken, loading: loadingToken, error: errorToken },
    executeToken,
  ] = useAxios({ url: 'users/token', method: 'POST' }, { manual: true });

  //Get logout request
  const [
    { data: dataLogout, loading: loadingLogout, error: errorLogout },
    executeLogout,
  ] = useAxios(`logout`, { manual: true });

  useEffect(() => {
    if (dataLogout !== undefined) {
      reactLocalStorage.remove('user')
      reactLocalStorage.remove('token')
      navigate('/login')
    }
  }, [dataLogout])

  const [
    { data: dataDetail, loading: loadingDetail, error: errorDetail },
    executeDetail,
  ] = useAxios(
    {
      url: 'organizations/details',
      params: { name: orgName }
    },
    { manual: !orgName }
  );

  useEffect(() => {
    if (errorLogin) {
      const {
        response: { status, data: { message: errMessage } } = {},
      } = errorLogin;
      if (status) {
        if (status === 423) {
          setMessage(errMessage);
          setShow(true);
        } else if (status === 451) {
          setShowAcceptTerms(true)
        } else {
          setInvalid(true)
        }
      }
    }
  }, [errorLogin]);

  useEffect(() => {
    if (dataLogin) {
      //TODO: save the credentials
      const { user_id, token } = dataLogin;
      // setCookie("token", token, 2);
      reactLocalStorage.set('token', token);
      setUserId(user_id);
    }
  }, [dataLogin]);

  useEffect(() => {
    if (userId) {
      executeUser();
    }
  }, [userId, executeUser]);

  useEffect(() => {
    if (dataUser) {
      const { organization } = dataUser;
      setOrgName(organization?.name);

      //If you login as an admin
      if (!organization) {
        const userData = {
          ...dataUser,
          organization: {
            ...dataUser.organization,
            ...dataDetail?.detail?.organization,
          },
        }
        //Set storage
        reactLocalStorage.setObject('user', userData);
        //redirect
        if (login) navigate('/');
      }
    }
  }, [dataUser]);

  useEffect(() => {
    if (dataDetail) {
      const userData = {
        ...dataUser,
        organization: {
          ...dataUser.organization,
          ...dataDetail?.detail?.organization,
        },
      }
      //Set storage
      reactLocalStorage.setObject('user', userData);
      //redirect
      if (login) navigate('/');
    }
  }, [dataDetail])

  const onSubmit = (values) => {
    //make the request
    setInvalid(false);
    executeLogin({ data: values });
  };

  const onSubmitForce = (values) => {
    //make the request forced
    executeLogin({ data: { ...values, force: true } });
    setShow(false);
  };

  const onAcceptTerms = (values) => {
    setShowAcceptTerms()
    executeLogin({ data: { ...values, acceptedTerms: true } });
  }

  // `users/snoozed-review`
  const [
    {
      data: dataSnoozedReview,
      loading: loadingSnoozedReview,
      error: errorSnoozedReview,
    },
    getSnoozedReview,
  ] = useAxios(
    {
      url: 'users/snoozed-review',
      method: 'GET',
    },
    { manual: true }
  )

  // saveSnoozedReview
  const [{ data: dataSaveSnoozedReview, loading: loadingSaveSnoozed }, saveSnoozedReview] = useAxios(
    { url: 'users/snoozed-review', method: 'POST' },
    { manual: true }
  )

  return {
    onSubmit,
    dataLogin,
    loadingLogin,
    errorLogin,
    onSubmitForce,
    show,
    setShow,
    message,
    invalid,
    loadingUser,
    hideChange,
    setHideChange,
    errorUser,
    dataToken,
    loadingToken,
    errorToken,
    executeToken,
    executeLogout,
    dataLogout,
    loadingLogout,
    errorLogout,
    setUserId,
    dataUser,
    loadingDetail,
    showAcceptTerms,
    setShowAcceptTerms,
    onAcceptTerms,
    dataSnoozedReview,
    loadingSnoozedReview,
    saveSnoozedReview,
    getSnoozedReview,
    loadingSaveSnoozed,
  };
};
